const defaultState = {
  infoitems: [],
};

export default function infoitems_reducer(state = defaultState, action) {
  let infoitems;
  switch (action.type) {
    case "SET_INFO_ITEMS":
      return {
        ...state,
        infoitems: action.payload,
      };
      break;
    case "ADD_INFO_ITEM":
      infoitems = [...state.infoitems];
      infoitems.unshift(action.payload);
      return {
        ...state,
        infoitems,
      };
      break;
    case "PATCH_INFO_ITEM":
      infoitems = [...state.infoitems];
      let index = infoitems.findIndex((i) => i.id === action.payload.id);
      infoitems.splice(index, 1, action.payload);
      return {
        ...state,
        infoitems,
      };
      break;
    default:
      return state;
  }
}
